import {
  DrawingDocumentOptionDto,
  DrawingDto,
} from 'src/api/FiretrolApiClient';
import { drawingApiClient } from 'src/api/FiretrolApiClientInstances';
import { createModuleQueries } from 'src/api/queries/workflowModules/createModuleQueries';
import { queryKeys } from 'src/api/queries/queryKeys';

const queries = createModuleQueries<DrawingDto, DrawingDocumentOptionDto>({
  label: 'drawing',
  listKey: queryKeys.drawings.list,
  detailKey: queryKeys.drawings.detail,
  documentOptionsKey: queryKeys.drawings.documentOptions,
  list: (jobId, ct) => drawingApiClient.getDrawingsByJob(jobId, ct),
  detail: (jobId, id, ct) => drawingApiClient.getDrawingById(jobId, id, ct),
  documentOptions: (jobId, ct) =>
    drawingApiClient.getDocumentOptions(jobId, ct),
});

export const useDrawingsList = queries.useList;
export const useDrawing = queries.useDetail;
export const useDrawingDocumentOptions = queries.useDocumentOptions;
